import "./style.css";

export default class ProgramDetailsComponent {
    static selector = ".program-details-component";
  
    constructor(block) {
      this.block = block;
      this.tabLink1 = this.block.querySelector(".tabLink1");
      this.tabLink2 = this.block.querySelector(".tabLink2");
      this.tabLink3 = this.block.querySelector(".tabLink3");
      this.tabLink4 = this.block.querySelector(".tabLink4");
    //  this.tabLink5 = this.block.querySelector(".tabLink5");

      this.tabLink1.addEventListener("click", this.ontabLink1Click);
      this.tabLink2.addEventListener("click", this.ontabLink2Click);
      this.tabLink3.addEventListener("click", this.ontabLink3Click);
      this.tabLink4.addEventListener("click", this.ontabLink4Click);
    //  this.tabLink5.addEventListener("click", this.ontabLink5Click);
    }

    ontabLink1Click = (e) => { 
      e.preventDefault(),
      this.contentDivs = this.block.querySelectorAll(".tabContent > div");
      for (const divContent of this.contentDivs) {
        divContent.style.display = "none";        
      }
      this.block.querySelector(".tabs a.active").classList.remove("active");
      this.block.querySelector(".tabLink1").classList.toggle("active");
      this.block.querySelector("#tab1").style.display = "block";
    }; 
    ontabLink2Click = (e) => { 
      e.preventDefault(),
      this.contentDivs = this.block.querySelectorAll(".tabContent > div");
      for (const divContent of this.contentDivs) {
        divContent.style.display = "none";        
      }
      this.block.querySelector(".tabs a.active").classList.remove("active");
      this.block.querySelector(".tabLink2").classList.toggle("active");
      this.block.querySelector("#tab2").style.display = "block";
    };
    ontabLink3Click = (e) => { 
      e.preventDefault(),
      this.contentDivs = this.block.querySelectorAll(".tabContent > div");
      for (const divContent of this.contentDivs) {
        divContent.style.display = "none";        
      }
      this.block.querySelector(".tabs a.active").classList.remove("active");
      this.block.querySelector(".tabLink3").classList.toggle("active");
      this.block.querySelector("#tab3").style.display = "block";
    }; 
    ontabLink4Click = (e) => { 
      e.preventDefault(),
      this.contentDivs = this.block.querySelectorAll(".tabContent > div");
      for (const divContent of this.contentDivs) {
        divContent.style.display = "none";        
      }
      this.block.querySelector(".tabs a.active").classList.remove("active");
      this.block.querySelector(".tabLink4").classList.toggle("active");
      this.block.querySelector("#tab4").style.display = "block";
    }; 
    ontabLink5Click = (e) => { 
      e.preventDefault(),
      this.contentDivs = this.block.querySelectorAll(".tabContent > div");
      for (const divContent of this.contentDivs) {
        divContent.style.display = "none";        
      }
      this.block.querySelector(".tabs a.active").classList.remove("active");
      this.block.querySelector(".tabLink5").classList.toggle("active");
      this.block.querySelector("#tab5").style.display = "block";
    };  
    
  }


  